module.exports = __webpack_public_path__ + "img/architecture_diagram.dc895742.png";